import { useQuery, useMutation } from '@apollo/client/react'
import { GET_DASHBOARD_INSIGHTS, REFRESH_DASHBOARD_INSIGHTS } from '../lib/operations/dashboard'
import { DashboardInsights } from '../lib/types'

export function useDashboardInsights(clientId: string | null) {
  const { data, loading, error } = useQuery<{ dashboardInsights: DashboardInsights | null }>(
    GET_DASHBOARD_INSIGHTS,
    { variables: { clientId }, skip: !clientId },
  )

  const [refresh, { loading: refreshing }] = useMutation<{
    refreshDashboardInsights: DashboardInsights
  }>(REFRESH_DASHBOARD_INSIGHTS, {
    variables: { clientId },
    update(cache, { data: mutationData }) {
      if (!mutationData) return
      cache.writeQuery({
        query: GET_DASHBOARD_INSIGHTS,
        variables: { clientId },
        data: { dashboardInsights: mutationData.refreshDashboardInsights },
      })
    },
  })

  return {
    insights: data?.dashboardInsights ?? null,
    loading,
    error,
    refresh,
    refreshing,
  }
}
